export default "__VITE_ASSET__IT7Nb0bW__"